module.exports = __webpack_public_path__ + "static/media/Belijning_E3West_4@2x.8852a417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/04/assets/Belijning_E3West_4@2x.jpg
// module id = 477
// module chunks = 0